import { Combobox } from "@/components/ui/combobox";
import { HttpMethod } from "@/components/ui/http-method";
import { StatusCode } from "@/components/ui/status-code";
import { cn } from "@/lib/utils";
import { Check } from "lucide-react";
import type { Endpoint } from "../../../../schemas";

interface EndpointComboboxProps {
  endpoints: Endpoint[];
  value: Endpoint;
  onChange: (endpoint: Endpoint) => void;
  className?: string;
}

export function EndpointCombobox({
  endpoints,
  value,
  onChange,
  className,
}: EndpointComboboxProps) {
  const getEndpointLabel = (endpoint: Endpoint) =>
    `${endpoint.method} ${endpoint.path}`;

  const renderTrigger = (endpoint: Endpoint) => (
    <div className="flex items-center gap-2 w-full">
      <StatusCode statusCode={endpoint.statusCode} />
      <HttpMethod method={endpoint.method} />
      <span className="text-foreground flex-1 text-left truncate">
        {endpoint.path}
      </span>
    </div>
  );

  const renderItem = (endpoint: Endpoint, isSelected: boolean) => (
    <>
      <div className="flex items-center gap-2 w-full">
        <HttpMethod method={endpoint.method} />
        <span className="flex-1 truncate">{endpoint.path}</span>
      </div>
      <div className="flex items-center gap-2">
        <Check
          className={cn("h-4 w-4", isSelected ? "opacity-100" : "opacity-0")}
        />
      </div>
    </>
  );

  return (
    <Combobox
      items={endpoints}
      value={value}
      onChange={onChange}
      getItemKey={(endpoint) => endpoint.value}
      getSearchableText={getEndpointLabel}
      renderTrigger={renderTrigger}
      renderItem={renderItem}
      placeholder="Search endpoints..."
      emptyMessage="No endpoint found."
      className={cn("font-mono bg-input hover:bg-input px-3 py-2", className)}
    />
  );
}
